import React from 'react';
import Attribute from './common';
import { SubText } from '../../../common';

const notice = `A different colour from the original is perfectly legal
and there may be good reasons. Look for other evidence of modifications
that may cost more to insure.`;

interface Props {
    passed: boolean;
}

const OriginalColour: React.FC<Props> = ({ passed }) => (
    <Attribute name="Original colour" passed={passed}>
        <SubText>{notice}</SubText>
    </Attribute>
);

export default OriginalColour;
